import * as moment from 'moment';
import { AnalyticService } from '../../apis/analytics';
import { FETCH_TOTAL_ORDERS_END } from '../mutations.type';
import { FETCH_TOTAL_ORDERS } from '../actions.type';

const initialState = {
  chartData: {
    datasets: [
      {
        data: [],
      },
    ],
  },
  options: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 50,
          },
        },
      ],
      xAxes: [
        {
          type: 'time',
          time: {
            displayFormats: {
              hour: 'hA',
            },
          },
          ticks: {
            maxTicksLimit: 4,
            maxRotation: 0,
            padding: 10,
            fontSize: 12,
          },
          gridLines: { display: false },
        },
      ],
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
  },
  totalOrders: 0,
  uselTotalOrders: 0,
  onlineStoreOrders: 0,
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_TOTAL_ORDERS](context, args) {
    let strStores = Array.isArray(args.stores) ? args?.stores.join(',') : args.stores;
    const { data } = await AnalyticService.fetchTotalOrders(args.fromTime, args.toTime, strStores, args?.timezone);
    let maxValue = Math.max(...data.details.dataset);
    let stepSize = maxValue === 0 ? 20 : maxValue > 20 ? Math.round(maxValue / 4) : maxValue;
    initialState.options.scales.yAxes[0].ticks.stepSize = stepSize;
    let dataset = {
      label: 'Orders',
      data: data.details.dataset,
      borderColor: '#058b45',
      backgroundColor: '#eefff5',
      pointBackgroundColor: '#058b45',
      fill: true,
      pointRadius: 1,
      pointHitRadius: 1,
    };

    let rs = {
      chartData: { datasets: [dataset], labels: data.details.labels },
      options: { ...initialState.options },
      totalOrders: data?.total_orders,
      uselTotalOrders: data?.upsell_orders,
      onlineStoreOrders: data?.online_store_orders,
    };
    context.commit(FETCH_TOTAL_ORDERS_END, rs);
    return rs;
  },
};

/* eslint no-param-reassign: ['error', { 'props': false }] */
export const mutations = {
  [FETCH_TOTAL_ORDERS_END](state, data) {
    state.chartData = data.chartData;
    state.options = data.options;
    state.totalOrders = data.totalOrders;
    state.uselTotalOrders = data.uselTotalOrders;
    state.onlineStoreOrders = data.onlineStoreOrders;
  },
};

const getters = {
  chartOrdersData(state) {
    return state.chartData;
  },
  chartOrdersOpts(state) {
    return state.options;
  },
  totalOrders(state) {
    return state.totalOrders;
  },
  uselTotalOrders(state) {
    return state.uselTotalOrders;
  },
  onlineStoreOrders(state) {
    return state.onlineStoreOrders;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
